// React dates
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import lodash from 'lodash';
import { formatPhoneNumber } from './utils/formatter';
import { htmlDecode } from './utils/htmlDecoder';

// Entry point for React bootstrap
import "global/semantic-ui.starfish";

import IntakeTopFilterPanel from './intake/IntakeTopFilterPanel';
import { IntakeQuestionFilterPanel } from './intake/IntakeQuestionFilterPanel';
import RecommendedInterventionsApp from './recommendedInterventions/App';
import ScoreDefinitionLinks from './recommendedInterventions/scoreFactors/ScoreDefinitionLinks';
import StudentDashboard from './studentDashboard/App';
import StudentSuccessNetworkDropdown from './SF/StudentSuccessNetworkDropdown';
import ServiceCatalogApp from './serviceCatalog/App';
import UpcomingApp from './upcoming/App';
import StudentIntake from './studentIntake/App'
import KioskApp from './kiosk/App';
import WaitingRoomApp from './waitingRoom/App';
import SurveysApp from './progressSurveys/App';
import StudentsTabs from './studentsTabs/App';
import Header from './header/Header';
import SaveSearchFilter from './saveSearchFilter/SaveSearchFilter';
import MainNavigation from './navigation/Navigation';
import AttendanceRoster from './attendance/AttendanceRoster';
import SearchFiltersConverter from './studentList/SearchFiltersConverter';
import StudentList from './studentList/StudentList';
import InterventionList from './interventionList/InterventionList';
import IntakeStudentList from './intake/IntakeStudentList';
import BatchSentItemsApp from './staffDashboard/BatchSentItemsApp';
import BatchActionNotification from './studentList/BatchActionNotification';
import BulkActionConfirm from './studentList/BulkActionConfirm';
import DeepLinks from './deepLinks/App';
import Toast from './common/Toast'
import Authentication from './authentication/App';
import InstitutionalProfile from './institutionalProfile/App';
import ReserveTimeAdmin from './reserveTime/admin/App';
import ReserveTimeModal from './reserveTime/modal/App';
import ScheduleBlockReportRequest from './scheduleBlockReport/App';
import CalendarLocking from './calendarLocking/App';
import StaffProfile from './profile/staff/App';
import StudentProfile from './profile/student/App';
import RequestHelp from './requestHelp/App';
import SystemAnnouncement from './systemAnnouncement/App';
import StudentView from './studentView/App';
import UserProfileSettings from './admin/userProfileSettings/App';
import AdminHelpDeskInformation from './admin/helpDeskInformation/App';
import printJS from './print';
import * as link from './link';
import errors from './error/SFError'
import ErrorModal from "./common/ErrorModal";
import './calendarLocking/UnlockedCalendars';
import TermsOfUse from "./common/TermsOfUse";
import HelpPage from "helpPage/HelpPage";
import sanitizeHtml from 'sanitize-html';
import KioskError from './kiosk/KioskError';
import KioskCheckBackSoon from './kiosk/virtual/CheckBackSoon';
import HelpModal from './helpPage/App';
import VirtualKioskSettings from "./admin/virtualKioskSettings/App";
import * as sessionTimeoutWarning from './sessionTimeout/index';
import AccessDenied from "./common/AccessDenied";
import SuccessScore from './successScore/App';
import StudentFolderSuccessScore from './studentFolder/successScore/App';
import SelfServiceDataExtracts from './selfServiceDataExtracts/App';
import StudentSurveys from './admin/studentSurveys/App';

import React from 'react';
import ReactDOM from 'react-dom';

if (!jsBuildEnv.production) {
  console.debug("React bootstrapping in developer build");
}

const renderer = (ReactComponent) => (targetDOMNode, componentProps) => {
  ReactDOM.render(<ReactComponent {...componentProps} />, targetDOMNode);
};

SF.react = {
  errors,
  printJS,
  link,
  sanitizeHtml,
  sessionTimeoutWarning,
  renderAdminHelpDeskInformation: renderer(AdminHelpDeskInformation),
  renderAttendanceRoster: renderer(AttendanceRoster),
  renderAuthentication: renderer(Authentication),
  renderBatchActionNotification: renderer(BatchActionNotification),
  renderBulkActionConfirm: renderer(BulkActionConfirm),
  renderCalendarLocking: renderer(CalendarLocking),
  renderInstitutionalProfile: renderer(InstitutionalProfile),
  renderIntakeTopFilterPanel: renderer(IntakeTopFilterPanel),
  renderIntakeQuestionFilterPanel: renderer(IntakeQuestionFilterPanel),
  renderIntakeStudentList: renderer(IntakeStudentList),
  renderRecommendedInterventions: renderer(RecommendedInterventionsApp),
  renderReserveTimeAdmin: renderer(ReserveTimeAdmin),
  renderSystemAnnouncement: renderer(SystemAnnouncement),
  renderReserveTimeModal: renderer(ReserveTimeModal),
  renderScoreDefinitionLinks: renderer(ScoreDefinitionLinks),
  renderStudentDashboard: renderer(StudentDashboard),
  renderStudentSuccessNetworkDropdown: renderer(StudentSuccessNetworkDropdown),
  renderStudentList: renderer(StudentList),
  renderStudentsTabs: renderer(StudentsTabs),
  renderInterventionList: renderer(InterventionList),
  renderServiceCatalog: renderer(ServiceCatalogApp),
  renderUpcoming: renderer(UpcomingApp),
  renderStudentIntake: renderer(StudentIntake),
  renderMainNavigation: renderer(MainNavigation),
  renderHeader: renderer(Header),
  renderSaveSearchFilter: renderer(SaveSearchFilter),
  renderSurveys: renderer(SurveysApp),
  renderKiosk: renderer(KioskApp),
  renderKioskError: renderer(KioskError),
  renderKioskCheckBackSoon: renderer(KioskCheckBackSoon),
  renderWaitingRoom: renderer(WaitingRoomApp),
  renderBatchSentItems: renderer(BatchSentItemsApp),
  renderDeepLinks: renderer(DeepLinks),
  renderScheduleBlockReportRequest: renderer(ScheduleBlockReportRequest),
  renderToast: renderer(Toast),
  renderStaffProfile: renderer(StaffProfile),
  renderStudentProfile: renderer(StudentProfile),
  renderRequestHelp: renderer(RequestHelp),
  renderStudentView: renderer(StudentView),
  renderSuccessScore: renderer(SuccessScore),
  renderUserProfileSettings: renderer(UserProfileSettings),
  toSearchFilters: SearchFiltersConverter.toSearchFilters,
  toStudentListParameters: SearchFiltersConverter.toStudentListParameters,
  renderErrorModal: renderer(ErrorModal),
  renderTermsOfUse: renderer(TermsOfUse),
  renderHelpPage: renderer(HelpPage),
  renderHelpDeskModal: renderer(HelpModal),
  renderVirtualKioskSettings: renderer(VirtualKioskSettings),
  renderAccessDenied: renderer(AccessDenied),
  renderStudentFolderSuccessScore: renderer(StudentFolderSuccessScore),
  renderSelfServiceDataExtract: renderer(SelfServiceDataExtracts),
  renderStudentSurveys: renderer(StudentSurveys)
};

SF.lodash = lodash;
SF.formatter = {
  toNationalPhoneNumber: formatPhoneNumber
};
SF.htmlDecode = htmlDecode;

window.appReady = true;
